﻿import React, { useRef, useState, useEffect, useCallback } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  selectConnection,
  selectAllWorkflows,
} from "@/features/homepage/homeSlice";
import { selectWorkflow } from "@/features/homepage/workflowManagerSessionSlice";
import {
  ExitToApp as ExitToAppIcon,
  WidthWide as WidthWideIcon
} from "@mui/icons-material";
import ArtifactMap from "./ArtifactMap";
import { ArtifactMapIcon } from "@/ImageRepo";

const ArtifactsMapPanel = () => {
  const dispatch = useDispatch();
  const selectedConnection = useSelector(selectConnection);
  const selectedWorkflow = useSelector(selectWorkflow);
  const workflows = useSelector(selectAllWorkflows);

  const getArtifactMapWorkflowSubheader = () => {
    const selectedWorkflowDetails = workflows.find(
      (workflow) => workflow.OperationId === selectedWorkflow
    );

    if (selectedWorkflowDetails) {
      return selectedWorkflowDetails.OperationName;
    }

    return selectedWorkflow === 0 ? "All Workflows" : selectedWorkflow;
  };

  const getArtifactMapConnectionSubheader = () => {
    return selectedConnection === "All"
      ? "All Connections"
      : selectedConnection.DisplayName;
  };

  const [isShrunk, setIsShrunk] = useState(false);

  const handleExitClick = useCallback(() => {
    setIsShrunk((prev) => {
        // heap.io
        if (prev) {
            window.heap.track("Workflow Map - Expand");
        }
        else {
            window.heap.track("Workflow Map - Collapse");
        }

        return !prev
    });
  }, []);

  return (
    <div
      style={{ width: isShrunk ? "150px" : "620px", transition: "width 0.3s" }}
    >
      <Paper
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          borderRadius: "15px 15px 0 0",
          height: "58px",
          backgroundColor: "var(--primary-main)",
        }}
      >
        {!isShrunk && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                color: "var(--default-light)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(font-bold)",
              }}
            >
              Map
            </Typography>
            <Typography
              variant="h7"
              sx={{
                textAlign: "center",
                color: "var(--default-light)",
                fontFamily: "var(--font-family)",
              }}
            >
              {`${getArtifactMapConnectionSubheader()} - ${getArtifactMapWorkflowSubheader()}`}
            </Typography>
          </Box>
        )}

        <ExitToAppIcon
          sx={{
            alignSelf: "center",
            cursor: "pointer",
            color: "var(--default-light)",
            marginLeft: "auto",
            transform: isShrunk ? "none" : "scaleX(-1)",
          }}
          onClick={handleExitClick}
        />
      </Paper>

      <Paper
        sx={{
          padding: "25px",
          borderRadius: "0 0 16px 16px",
          backgroundColor: "var(--default-light)",
          position: "relative",
          width: isShrunk ? "100px" : "570px",
          height: "2550px",
          transition: "width 0.3s",
        }}
      >
        {isShrunk && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ArtifactMapIcon
              style={{
                cursor: "pointer",
              }}
              onClick={handleExitClick}
            />
          </div>
        )}

        <div style={{ opacity: isShrunk ? 0 : 1, transition: "opacity 0.7s" }}>
          {!isShrunk && (
            <ArtifactMap
              workflows={workflows}
              selectedConnection={selectedConnection}
              selectedWorkflow={selectedWorkflow}
            />
          )}
        </div>
      </Paper>
    </div>
  );
};

export default ArtifactsMapPanel;
